// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppObjectSchema } from './v1/appObjectSchema';
import { v1AppObjectsUpdateSchema } from './v1/appObjects/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const patchAppObjectsPathParamsSchema = z.object({
  app_id: z.number().int().describe("AppUser id"),
  id: z.coerce.string().describe("Object id (not used in request, kept for REST convention)"),
});

export const patchAppObjectsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description App objects updated
 */
export const patchAppObjects200Schema = z.array(z.lazy(() => v1AppObjectSchema));

/**
 * @description AppUser not found
 */
export const patchAppObjects404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity - Invalid objects data
 */
export const patchAppObjects422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const patchAppObjectsMutationRequestSchema = z.lazy(() => v1AppObjectsUpdateSchema);

export const patchAppObjectsMutationResponseSchema = z.lazy(() => patchAppObjects200Schema);
